import axiosIns from 'utils/axios';
import { postRequest } from 'utils/httpServices';

class payoutReportsAPI {
  static getCummalativeReportCard = (queryData = {}, config = {}) => {
    return postRequest(
      `v2/payout-report/fetch-payout-cummalative-summary`,
      queryData,
      config
    ).catch((error) => ({
      success: false,
      data: error.response?.data || {},
      status: error.name === 'AbortError' ? 499 : error.response?.status || 400
    }));
  };

  static getCummalativePayoutReports = (queryData = {}, config = {}) => {
    return postRequest(
      `v2/payout-report/fetch-payout-cummalative-reports`,
      queryData,
      config
    ).catch((error) => ({
      success: false,
      data: error.response?.data || {},
      status: error.name === 'AbortError' ? 499 : error.response?.status || 400
    }));
  };

  static downloadBulkReports = (queryData = {}, config = {}) => {
    return postRequest(
      `v2/payout-report/bulk-payout-and-invoice-download`,
      queryData,
      config
    ).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static downloadablePayoutCummalativeReport = (queryData = {}, config = {}) => {
    return axiosIns
      .request({
        url: 'v2/payout-report/download-payout-cummalative-reports',
        method: 'POST',
        responseType: 'blob',
        data: queryData,
        headers: config.headers
      })
      .catch(() => ({ success: false, data: 'Something went wrong', status: 500 }));
  };

  static getScenerioReportCard = (queryData = {}, config = {}) => {
    return postRequest(
      `v2/payout-report/fetch-month-payout-summary-cards`,
      queryData,
      config
    ).catch((error) => ({
      success: false,
      data: error.response?.data || {},
      status: error.name === 'AbortError' ? 499 : error.response?.status || 400
    }));
  };

  static getSceneriosBasedPayouts = (queryData = {}, config = {}) => {
    return postRequest(`v2/payout-report/fetch-month-payout-reports`, queryData, config).catch(
      (error) => ({
        success: false,
        data: error.response?.data || {},
        status: error.name === 'AbortError' ? 499 : error.response?.status || 400
      })
    );
  };

  static downloadS3Reports = (queryData = {}, config = {}) => {
    return postRequest(`v1/report/generate-signed-url`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static bulkInvoiceSubmit = (queryData = {}, config = {}) => {
    return postRequest(`v2/payout-report/bulk-upload-invoice`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static PendingPayoutSummary = (queryData = {}, config = {}) => {
    return postRequest(`v2/payout-report/bulk-payout-invoice-summary`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };
}

export default payoutReportsAPI;
